"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getSafeOptions;
var UPDATE_KEYS = ['persistedProperties', 'integrations', 'enabled', 'appId'];

function getSafeOptions(options) {
  return UPDATE_KEYS.reduce((acc, key) => {
    if (key in options) {
      acc[key] = options[key];
    }

    return acc;
  }, {});
}
//# sourceMappingURL=getSafeOptions.js.map